export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-maneuver-instructions-960-d38f84181fe183607b50a09b085f4668.webp";